import React, { useState } from "react";
import Navbar from "../Navbar";
import { Row } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { toastSuccess, toastError } from "../../utilis/toast";
import { FaEnvelope } from "react-icons/fa";
import axios from "axios";
import { API } from "../../API";
import { useHistory, Link } from "react-router-dom";

import { useAppContext } from "../../Context/AppContext";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const { headerLogo } = useAppContext();
    const history = useHistory();

    const handleChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        if (!/\S+@\S+\.\S+/.test(value)) {
            setError("Invalid email format");
        } else {
            setError("");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (error) return;

        setLoading(true);

        try {
            const response = await axios.post(`${API}/api/user/password/forgot`, {
                email,
            });

            if (response && response.data) {

                toastSuccess(response.data.message || "passwork  sent to your email");

                setTimeout(() => {
                    history.push("/login");
                }, 800); // Delay so toast is visible
            }
            setEmail("");
        } catch (err) {
            toastError(
                err?.response?.data?.message || "Something went wrong. Try again."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Navbar />

            <div className="d-flex justify-content-center align-items-center mt-5">
                <div
                    className="bg-white rounded shadow p-4"
                    style={{ width: "100%", maxWidth: "440px" }}
                >

                    <div className="text-center mb-3">
                        {headerLogo ? (
                            <img src={headerLogo} alt="Logo" width={250} className="img-fluid" />
                        ) : (
                            <h1 className="text-primary fw-bold">SoComOTT</h1>
                        )}
                    </div>

                    <h3 className="text-center mb-3">Forgot Password</h3>
                    <p className="text-center text-muted">
                        Enter your email to receive a reset link
                    </p>

                    <form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <label className="form-label">
                                Email <span className="text-danger">*</span>
                            </label>

                            <div className="input-group">
                                <span className="input-group-text">
                                    <FaEnvelope />
                                </span>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={handleChange}
                                    placeholder="Enter your email"
                                    required
                                    className={`form-control ${error ? "is-invalid" : ""}`}
                                />
                            </div>

                            {error && <div className="text-danger mt-1">{error}</div>}
                        </Row>

                        <Row className="text-center">
                            <button
                                type="submit"
                                className="btn btn-primary w-100"
                                disabled={loading}
                            >
                                {loading ? "Sending..." : "Send Reset Link"}
                            </button>
                        </Row>
                    </form>

                    <div className="text-center text-muted mt-3">
                        <Link to="/login">Back to Login</Link>
                    </div>
                </div>
            </div>

            <ToastContainer position="top-center" autoClose={2000} />
        </>
    );
};

export default ForgotPassword;
